const cameraIcon = "/images/work-orders/camera-icon.png"
const galleryIcon = "/images/work-orders/gallery-icon.png"

export {
    cameraIcon,
    galleryIcon,
}